
define('jst!shared/dropdown/_dropdown_item',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<% _.each(items, function(item) { %>\n  <li role="presentation">\n    <a role="menuitem" tabindex="-1" href="#" data-id="<%=item.id ? item.id : \'\'%>">\n      <% if (item.iconClass) { %>\n        <span class="<%=item.iconClass%>"></span>\n      <% } %>\n      <%=item.label%>\n    </a>\n  </li>\n<% }); %>');
 });

